import React from "react";
import PremiumIconSvg from "../components/Svg/PremiumIconSvg";
import StandardIconSvg from "../components/Svg/StandardIconSvg";
import FreeIcon from "../components/Svg/FreeIcon";


export const getAccessIcons = (access) => {
  if (!access) return null;

  const txt = access.toLowerCase()

  if (txt === 'pcp') return <PremiumIconSvg/>;
  if (txt === 'pc') return <StandardIconSvg/>;
  if (txt === 'free' || txt === 'ic') return <FreeIcon txt={txt}/>;

  return null;
}


export const getAccessIconsFromArray = (arr = []) => {
  if (arr.includes('free')) return <FreeIcon txt={'free'}/>;
  if (arr.includes('ic') && arr.length === 1) return <FreeIcon txt={'ic'}/>;
  if ((arr.includes('pcp') && arr.includes('pc')) || (arr.includes('pc') && arr.length === 1)) return (
    <>
      <StandardIconSvg/>
      <PremiumIconSvg/>
    </>
  );
  if (arr.includes('ic') && arr.includes('pc')) return (
    <>
      <StandardIconSvg/>
      <FreeIcon txt={'ic'}/>
    </>
  );
  if (arr.includes('pcp')) return <PremiumIconSvg/>;

  return <FreeIcon txt={'free'}/>;
}

export const getOnlyAccessTitle = (arr) => {
  if (arr.includes('pcp')) return 'premium'
  if (arr.includes('pc')) return 'standard'
  if (arr.includes('ic') && arr.length === 1) return 'inner circle';
  return 'free';
}

